import React from 'react';
import './advertisementBanner.scss';

export type AdvertisementBannerProps = {
  companyName?: string | null;
};

export const AdvertisementBanner: React.FC<AdvertisementBannerProps> = ({
  companyName,
}) => (
  <div className="advertisement-banner">
    <span className="advertisement-banner__title">ANNONS</span>
    <span className="advertisement-banner__company">
      {companyName && `Innehåll från ${companyName}`}
    </span>
  </div>
);
